(function () {
    'use strict';

    angular.module('MyDirectives', [])
        /**
         * HTML5 SignaturePad Directive
         * This directive is intended to place a canvas within a form
         * which can then be drawn upon. Once it is drawn updon, it will be
         * considered 'valid'
         *
         * Thanks to Thomas J Bradley for the Signature Pad plugin for jQuery
         * http://thomasjbradley.ca/lab/signature-pad/
         *
         */
        .directive('sigpad', function ($timeout) {
            return {
                templateUrl: 'views/sigPad.html', // Use a template in an external file
                restrict: 'E', // Must use <sigpad> element to invoke directive
                scope: true, // Create a new scope for the directive
                require: 'ngModel', // Require the ngModel controller for the linking function
                link: function (scope, element, attr, ctrl) {

                    // Attach the Signature Pad plugin to the template and keep a reference to the signature pad as 'sigPadAPI'
                    var sigPadAPI = $(element).signaturePad({
                        drawOnly: true,
                        lineColour: '#FFF',
                        penWidth: 6
                    });

                    // Clear the canvas when the 'clear' button is clicked
                    $(attr.clearbtn).on('click', function (e) {
                        sigPadAPI.clearCanvas();
                    });

                    $(element).find('.pad').on('touchend', function (obj) {
                        scope.updateModel();
                    });

                    // when the mouse is lifted from the canvas, set the signature pad data as the model value
                    scope.updateModel = function () {
                        $timeout(function () {
                            var sig = sigPadAPI.getSignature();
                            if (sig != null && sig.length == 0) {
                                var sig = null;
                            }
                            ctrl.$setViewValue(sig);
                        });
                    };

                    // Render the signature data when the model has data. Otherwise clear the canvas.
                    ctrl.$render = function () {
                        if (ctrl.$viewValue) {
                            sigPadAPI.regenerate(ctrl.$viewValue);
                        } else {
                            // This occurs when signatureData is set to null in the main controller
                            sigPadAPI.clearCanvas();
                        }
                    };

                    // Validate signature pad.
                    // See http://docs.angularjs.org/guide/forms for more detail on how this works.
                    ctrl.$parsers.unshift(function (viewValue) {
                        if (sigPadAPI.validateForm()) {
                            ctrl.$setValidity('sigpad', true);
                            return viewValue;
                        } else {
                            ctrl.$setValidity('sigpad', false);
                            //undefined to viewValue cause of bug
                            return viewValue;
                        }
                    });

                }
            };
        })
        /**
         * Regenerate Signature Pad data as Base64 encoded PNG data.
         * This uses the getSignatureImage() function of the Signature Pad API.
         * It only works in modern browsers, and is flaky in IE.
         */
        .directive('regensigpad', function () {
            return {
                template: '<img ng-src="{{pic}}" />',
                restrict: 'E',
                scope: {
                    sigdata: '@'
                },
                link: function (scope, element, attr, ctrl) {
                    // When the sigdata attribute changes...
                    attr.$observe('sigdata', function (val) {
                        // ... create a blank canvas template and attach the signature pad plugin
                        var sigPadAPI = $('<div class="sig sigWrapper"><canvas class="pad" width="436" height="120"></canvas></div>').signaturePad({
                            displayOnly: true
                        });
                        // regenerate the signature onto the canvas
                        if (val) {
                            sigPadAPI.regenerate(val);
                        } else {
                            // This occurs when signatureData is set to null in the main controller
                            sigPadAPI.clearCanvas();
                        }
                        // convert the canvas to a PNG (Newer versions of Chrome, FF, and Safari only.)
                        scope.pic = sigPadAPI.getSignatureImage();
                    });
                }
            };
        })

    /* Used to capture images from the device's camera
    * and resize them using given dimensions and quality
    * <input type="file" capture="camera" accept="image/*"
    	id="photoAddFile" image="imageBrowsed"
    onfilechange="imageChanged(data)"
    maxwidth="{{width}}" maxheight="{{height}}" quality="{{quality}}"
    imagetype="image/jpeg" >
    */
    .directive('image', function ($q) {
        'use strict'

        var URL = window.URL || window.webkitURL;

        return {
            restrict: 'A',
            scope: {
                /*image: '=',*/
                maxwidth: '@?',
                maxheight: '@?',
                quality: '@?',
                imagetype: '@?',
                onfilechange: '&'
            },
            link: function postLink(scope, element, attrs, ctrl) {
                var onFileChangeCallback = scope.onfilechange;
                var onFileFailureCallback = scope.onfileerror;
                var filename = "";
                var options;

                var getOptions = function () {
                    var options = {
                        maxWidth: parseFloat(scope.maxwidth) || 1024,
                        maxHeight: parseFloat(scope.maxheight) || 768,
                        quality: parseFloat(scope.quality) || 0.8,
                        imageType: scope.imagetype || 'image/jpeg',
                        canvas: true
                    };
                    return options;
                }

                var whenError = function (errorMessage) {
                    scope.$apply(function () {
                        if (typeof (onFileFailureCallback) == 'function') {
                            //to pass data in the message, we need to have an object with attrs named as in
                            //the html part, eg  onfilechange="imageChanged(data)"
                            onFileFailureCallback({
                                err: errorMessage
                            });
                        }
                    });
                }

                var whenReady = function (img) {
                    if (!(img.src || img instanceof HTMLCanvasElement)) {
                        whenError('Loading image file failed');
                    } else {
                        var data = img.src || img.toDataURL(options.imageType, options.quality);
                        var imageResult = {
                            dataURL: data,
                            fileName: filename,
                            fileType: options.imageType
                        };
                        scope.$apply(function () {
                            if (typeof (onFileChangeCallback) == 'function') {
                                //to pass data in the message, we need to have an object with attrs named as in
                                //the html part, eg  onfilechange="imageChanged(data)"
                                onFileChangeCallback({
                                    data: imageResult
                                });
                            }
                        });
                    }
                }

                element.bind('change', function (evt) {
                    evt.preventDefault();
                    //e = e.originalEvent;
                    var target = evt.dataTransfer || evt.target;
                    var files = target && target.files;
                    if (files) {
                        var file;
                        options = getOptions(); //read latest settings
                        for (var i = 0; i < files.length; i++) {
                            file = files[i];
                            filename = file.name;
                            //start by get metadata, to autoset the orientation of the image
                            loadImage.parseMetaData(file,
                                //when metadata are ready, use them and then load image
                                function (data) {
                                    if (data.exif) {
                                        options.orientation = data.exif.get('Orientation');
                                    }
                                    if (!loadImage(file, whenReady, options)) {
                                        whenError('Your browser does not support capturing images.');
                                    }
                                }
                            );
                        }
                    }
                });
            }
        };
    })

    .directive('integer', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$parsers.unshift(function (viewValue) {
                    var INTEGER_REGEXP = /^\-?\d+$/;
                    if (INTEGER_REGEXP.test(viewValue)) {
                        // it is valid
                        ctrl.$setValidity('integer', true);
                        return viewValue;
                    } else {
                        // it is invalid, return undefined (no model update)
                        ctrl.$setValidity('integer', false);
                        return undefined;
                    }
                });
            }
        };
    })

    .directive('smartFloat', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$parsers.unshift(function (viewValue) {
                    var FLOAT_REGEXP = /^\-?\d+((\.|\,)\d+)?$/;
                    if (FLOAT_REGEXP.test(viewValue)) {
                        ctrl.$setValidity('float', true);
                        return parseFloat(viewValue.replace(',', '.'));
                    } else {
                        ctrl.$setValidity('float', false);
                        return undefined;
                    }
                });
            }
        };
    })

    .directive('validNumber', function () {
        return function (scope, element, attrs) {

            //        var keyCode = [8,9,37,39, 46,48,49,50,51,52,53,54,55,56,57 ,96,97,98,99,100,101,102,103,104,105,110];
            var keyCode = [8, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 110, 190];
            element.bind("keydown", function (event) {
                if ($.inArray(event.which, keyCode) == -1) {
                    scope.$apply(function () {
                        scope.$eval(attrs.onlyNum);
                        event.preventDefault();
                    });
                    event.preventDefault();
                }

            });
        };
    })

    .directive('chart', function () {
        var baseWidth = 600;
        var baseHeight = 400;

        return {
            restrict: 'E',
            template: '<canvas></canvas>',
            scope: {
                chartObject: "=value"
            },
            link: function (scope, element, attrs) {
                var canvas = element.find('canvas')[0];
                var context = canvas.getContext('2d');
                var chart;

                var options = {
                    type: attrs.type || "Line",
                    width: attrs.width || baseWidth,
                    height: attrs.height || baseHeight
                };
                canvas.width = options.width;
                canvas.height = options.height;
                chart = new Chart(context);

                if (scope.chartObject) {


                    scope.$watch(function () {
                        return element.attr('type');
                    }, function (value) {
                        if (!value) return;
                        options.type = value;
                        var chartType = options.type;
                        chart[chartType](scope.chartObject.data, scope.chartObject.options);
                    });

                    //Update when charts data changes
                    scope.$watch(function () {
                        return scope.chartObject;
                    }, function (value) {
                        if (!value) return;
                        var chartType = options.type;
                        chart[chartType](scope.chartObject.data, scope.chartObject.options);
                        if (scope.chartInstance) scope.chartInstance.destroy();
                        scope.chartInstance = chart[chartType](scope.chartObject.data, scope.chartObject.options);
                    }, true);

                }
            }
        }
    })

    .directive('canvasGauge', function () {
        return {
            restrict: 'E',
            replace: true,
            template: '<canvas></canvas>',
            scope: {
                val: '=value'
            },
            link: function ($scope, element, attrs) {

                var width = parseInt(attrs.width || '100');
                $scope.height = width * 0.55;
                element.attr('height', $scope.height + 'px');

                var placeholder = attrs.placeholder || '(@)';
                var mask = attrs.mask || placeholder;
                var canvas = element[0];

                var animID = 0;
                var curValue = 0;
                var endValue = 0;
                var oldValue = 0;
                var direction = 0;

                var render = function (val) {

                    var value = val || 0;

                    if (canvas.getContext) {
                        var ctx = canvas.getContext('2d');
                        ctx.clearRect(0, 0, canvas.width, canvas.height);

                        var calcPercent = function (total, perc) {
                            return (total * perc) / 100;
                        }

                        var per = ((value - $scope.min) * 100) / ($scope.max - $scope.min); // Value converted to percentage using min and max
                        var pad = calcPercent(canvas.width, 15); // Inner padding around the container
                        var x = canvas.width / 2; // x coordinate
                        var y = (canvas.width / 2.3); // y coordinate
                        var startAngle = 0; // Starting point on circle
                        var radius = x - pad; // Circle's radius
                        var lineWidth = (canvas.width / 8); // Thickness of the drawing tip
                        var fontSize = (canvas.width * 0.1); // Default size of the text font (10% of canvas width)

                        ctx.imageSmoothingEnabled = true;
                        ctx.shadowOffsetX = 0;
                        ctx.shadowOffsetY = 0;
                        ctx.shadowBlur = 0;

                        ctx.beginPath();
                        ctx.arc(x, y, radius, Math.PI, Math.PI * 2, false);
                        ctx.lineWidth = lineWidth;
                        ctx.strokeStyle = $scope.underColor;
                        ctx.stroke();
                        ctx.closePath();

                        var endAngle = ((Math.PI * per) / 100) + Math.PI;
                        ctx.beginPath();
                        ctx.arc(x, y, radius, Math.PI, endAngle, false);
                        ctx.lineWidth = lineWidth;
                        ctx.strokeStyle = $scope.overColor;
                        ctx.stroke();
                        ctx.closePath();

                        ctx.font = 'bold ' + fontSize + 'pt Calibri';
                        ctx.textAlign = 'center';
                        ctx.fillStyle = $scope.textColor;
                        ctx.shadowColor = $scope.shadeColors($scope.smallTextColor, -30);
                        ctx.shadowOffsetX = 1;
                        ctx.shadowOffsetY = 1;
                        ctx.shadowBlur = 0;
                        ctx.fillText(mask.replace(placeholder, parseFloat(value.toFixed(2)).toString()), x, y);

                        if (canvas.width > 119) {
                            y = (canvas.width / 2.2) + calcPercent(canvas.height, 10) + (canvas.width / 100) - 1;
                            x = pad;
                            ctx.font = 'normal ' + (fontSize / 2) + 'pt Calibri';
                            ctx.shadowOffsetX = 0;
                            ctx.shadowOffsetY = 0;
                            ctx.fillStyle = $scope.smallTextColor;
                            ctx.fillText($scope.min, x, y);

                            y = (canvas.width / 2.2) + calcPercent(canvas.height, 10) + (canvas.width / 100) - 1;
                            x = canvas.width - (pad);
                            ctx.font = 'normal ' + (fontSize / 2) + 'pt Calibri';
                            ctx.fillStyle = $scope.smallTextColor;
                            ctx.fillText($scope.max, x, y);
                        }
                    }
                }

                var animate = function () {

                    var flag = direction == 1 ? (curValue <= endValue) : (curValue >= endValue);
                    if (flag == true) {
                        render(curValue);

                        curValue += direction;
                        animID = requestAnimationFrame(animate);
                    } else {
                        oldValue = endValue;
                        render(endValue);
                        cancelAnimationFrame(animID);
                    }
                }

                $scope.shadeColors = function (color, percent) {

                    var f = parseInt(color.slice(1), 16),
                        t = percent < 0 ? 0 : 255;
                    var p = percent < 0 ? percent * -1 : percent;
                    var R = f >> 16;
                    var G = f >> 8 & 0x00FF;
                    var B = f & 0x0000FF;
                    return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
                }

                $scope.$watch('val', function (newval, oldval) {

                    $scope.min = attrs.min || 0;
                    $scope.max = attrs.max || 100;
                    $scope.underColor = attrs.underColor || '#EFEFEF';
                    $scope.overColor = attrs.overColor || '#000';
                    $scope.textColor = attrs.textColor || $scope.overColor
                    $scope.smallTextColor = attrs.smallTextColor || getComputedStyle(element[0]).getPropertyValue("color");

                    curValue = parseFloat(oldValue);
                    endValue = parseFloat(newval); //alert(curValue + ' -- ' + endValue);
                    direction = endValue < curValue ? -1 : 1;
                    animate();

                });

            }
        }
    })

    .directive('bsHasError', [function () {
        return {
            restrict: "A",
            link: function (scope, element, attrs, ctrl) {
                var input = element.find('input[ng-model]');
                if (input) {
                    scope.$watch(function () {
                        return input.hasClass('ng-invalid') && input.hasClass('ng-dirty');
                    }, function (isInvalid) {
                        element.toggleClass('has-error', isInvalid);
                    });
                }
            }
        };
}]);

})();